import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from './utils/cache'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    defaultActive: '', // 默认激活菜单
    isHiddenContainer: false, // 是否隐藏顶部和左侧菜单
    username: getUserInfo().username
  },
  mutations: {
    changeActive (state, active) {
      state.defaultActive = active
    },
    changeIsHiddenContainer (state, status) {
      state.isHiddenContainer = status
    },
    changeUserName (state, name) {
      state.username = name
    }
  },
  actions: {

  }
})
